import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from 'react-redux';
import { Row, Col } from "antd";
import moment, { now } from 'moment';
import { ModalSpamTitle, ModalForm } from "./styles"
import AccountModal from "../../../commons/components/AccountModal"
import AccountInputValue from "../../../commons/components/accountInputValue";
import AccountTextArea from "../../../commons/components/AccountTextArea";
import AccountSelect from "../../../commons/components/AccountSelect";
import AccountDatePicker from "../../../commons/components/AccountDatePicker";
import Loading from "../../../commons/components/loading";
import {
    setSelectedCertification,
    setModeCertificationModal,
    setShowCertificationModal,
} from '../../../store/actions/certificationActions';

import modes from './certificationModalModes'
import Http from "../../../commons/utils/Http";
import Message from "../../../commons/utils/message";

function ModalCertification({ onSave }) {
    const dispatch = useDispatch();
    const { showCertificationModal, modeCertificationModal, selectedCertification, selectedUser } = useSelector((state) => state.certification);
    const { id: modificationUserId } = useSelector((state) => state.userLogin.userData);
    const [loading, setLoading] = useState(false);

    const [certification, setCertification] = useState({});
    const [certificate, setCertificate] = useState({});
    const [certificates, setCertificates] = useState([]);

    const [hasErrorCertificate, setHasErrorCertificate] = useState(false);
    const [errorMessageCertificate, setErrorMessageCertificate] = useState("");

    const dateFormat = 'DD/MM/YYYY';
    const dateFormatDataBase = 'YYYY-MM-DD';

    let [limitCharacter, setLimitCharacter] = useState(0);

    const [hasLimitLength, setLimitLength] = useState("");
    const [msgLimitLength, setMsgLimitLength] = useState("");

    useEffect(() => {
        if(selectedCertification.id){
            if (modeCertificationModal != modes.INSERT) {
                getCertificate(selectedCertification.certificate_id);
                setCertification(selectedCertification);
                if(selectedCertification.observation) {
                    setLimitCharacter(selectedCertification.observation.length)
                }
            }
        }        
    }, [selectedCertification]);

    async function searchCertificates(search) {
        try {    
            const body = {
                "search": search,
                "order_fields": ["name"],
                "order_type": "asc",
                "conditions": { "active": true }
            }
            let response = await Http.post(`/certificates/search-by`, body, Http.headers)
            const responseData = response.data.response
            if (!responseData.error) {
                return response.data.data.data
            }
        } catch (e) {     
            return null
        }
    }

    async function getCertificate(certificateId) {
        setLoading(true);
        try {
            
            let response = await Http.get(`/certificates/get-by?field=id&value=${certificateId}`, Http.headers);
            const responseData = response.data.response
            if (!responseData.error) {
                setCertificate(formatCertificatesData(response.data.data)[0]);
            }
        } catch (e) {     
            setCertificate({});
        }
        setLoading(false);
    }

    async function updateCertification(data) {
        try {
            let body = {
                "certification_id": data.id,
                "certificate_date": data.certificate_date ? moment(data.certificate_date, dateFormat).format(dateFormatDataBase) : null,
                "expiration_date": data.expiration_date ? moment(data.expiration_date, dateFormat).format(dateFormatDataBase) : null,
                "grade": data.grade ? data.grade : null,
                "observation": data.observation ? data.observation : null,
                "modification_user_id": modificationUserId,
            }

            await Http.put(`/users/update-user-certification`, body, Http.headers)

            onSave();
            handleClear();

        } catch (error) {
            // Error
            if (error.response) {
                Message.showError(error.response.data.response.message);
            }
            else if (error.request) {
                Message.showError("Erro ao atualizar certificação.");
            }
            else {
                Message.showError("Erro ao atualizar certificação.");
            }
        }
    }

    async function insertCertification(data) {
        try {
            let body = {
                "user_id": selectedUser.id,
                "certificate_id": data.certificate_id,
                "certificate_date": data.certificate_date ? moment(data.certificate_date, dateFormat).format(dateFormatDataBase) : null,
                "expiration_date": data.expiration_date ? moment(data.expiration_date, dateFormat).format(dateFormatDataBase) : null,
                "grade": data.grade ? data.grade : null,
                "observation": data.observation ? data.observation : null,
                "modification_user_id": modificationUserId,
            }

            await Http.post(`/users/insert-user-certification`, body, Http.headers)

            onSave();
            handleClear();
        } catch (error) {
            // Error
            if (error.response) {
                Message.showError(error.response.data.response.message);
            }
            else if (error.request) {
                Message.showError("Erro ao inserir certificação.");
            }
            else {
                Message.showError("Erro ao inserir certificação.");
            }
        }
    }

    function validateForm() {
        let valid = true;

        if (!certification.certificate_id) {
            setHasErrorCertificate(true);
            setErrorMessageCertificate("Informe uma certificação");
            valid = false;
        }

        return valid;
    }

    function formatCertificatesData(data) {
        let array = [];
        if (data) {
            data.forEach((dataItem) => {
                let item = {}
                item.label = `${dataItem.id} - ${dataItem.name}`;
                item.value = dataItem.id;
                array.push(item)
            })
        }
        return array;
    }

    function clearErrorCertificate(){
        setHasErrorCertificate(false);
        setErrorMessageCertificate("");
    }

    async function handleSearchCertificate(search) {
        const certificates = await searchCertificates(search);
        if (certificates) {
            setCertificates(formatCertificatesData(certificates));
        }
        clearErrorCertificate();
    }

    function handleChangeCertificate(e) {
        setCertification({ ...certification, certificate_id: e });
        setCertificate(certificates.find(item => item.value == e));

        clearErrorCertificate();
    }

    function handleChangeDateCertification(date, dateString) {
        setCertification({ ...certification, certificate_date: dateString })
    }

    function handleChangeDateExpiration(date, dateString) {
        setCertification({ ...certification, expiration_date: dateString });
    }

    function handleChangeGrade(e) {
        setCertification({ ...certification, grade: e.target.value })
    }

    function handleChangeObservation(e) {
        setCertification({ ...certification, observation: e.target.value })
    }

    function limitInputForm() {
        if (certification.observation) {
            setLimitCharacter(certification.observation.length)
            if (certification.observation.length >= 1000) {
                setLimitLength(true);
                setMsgLimitLength("O número máximo de caracteres é 1000");
            } else {
                setLimitLength(false);
                setMsgLimitLength("");
            }
        } else {
            setLimitCharacter(0);
        }
    }

    function handleSaveModalCertification() {
        if (validateForm()) {
            if (certification.id && modeCertificationModal != modes.INSERT) {
                updateCertification(certification);
            } else {
                insertCertification(certification);
            }
        }
    }

    function handleClear() {
        dispatch(setShowCertificationModal(false));
        dispatch(setModeCertificationModal(null));
        dispatch(setSelectedCertification({}));
        
        setCertification({});
        setCertificate({});
        setCertificates([]);

        clearErrorCertificate();
        setLimitLength(false);
        setMsgLimitLength("");
        setLimitCharacter(0);
    }

    function renderButtons() {
        if (modeCertificationModal == modes.VIEW) {
            return (
                <button key="cancel" onClick={handleClear} className="ant-btn ant-btn-primary">Ok</button>
            )
        } else {
            return (
                <>
                    <button key="cancel" onClick={handleClear} className="ant-btn">Cancelar</button>
                    <button key="confirm" onClick={handleSaveModalCertification} className="ant-btn ant-btn-primary">Salvar</button>
                </>
            )
        }
    }

    function renderTitle() {

        switch (modeCertificationModal) {
            case modes.INSERT:
                return 'Adicionar Certificação';
            case modes.EDIT:
                return 'Editar Certificação';

            default:
                return 'Visualizar Certificação';
        }
    }

    function renderModificationUserName() {
        let updateName = `Alterado por ${selectedCertification.modification_user_name} em`;
        let updateDate = `${selectedCertification.update_date} às ${selectedCertification.update_hour}`;
        let updateText = `${updateName} ${updateDate}`; 

        if(modeCertificationModal !== modes.INSERT) {
            return <span style={{ fontStyle: 'italic' }}>{updateText}</span>;
        }

        return null;
    }

    function renderForm() {
        if (loading) {
            return (
                <div style={{ display: "flex", justifyContent: "center", marginTop: 30 }}>
                    <Loading width={50} height={50} />
                </div>
            )
        } else {
            return (
                <>
                    { modeCertificationModal !== modes.VIEW ? <ModalSpamTitle>Preencha os dados</ModalSpamTitle> : null}
                    <ModalForm>
                        <ModalForm.Item>
                            <AccountInputValue
                                labelText={"Nome do usuário"}
                                value={selectedUser.name}
                                disabled={true} />
                        </ModalForm.Item>

                        <ModalForm.Item>
                            <AccountSelect
                                value={certificate.label}
                                labelText="Código ou descrição do certificado"
                                list={certificates}
                                onSearch={handleSearchCertificate}
                                onChange={handleChangeCertificate}
                                disabled={selectedCertification.id ? true : false}
                                hasError={hasErrorCertificate}
                                message={errorMessageCertificate} />
                        </ModalForm.Item>

                        <Row gutter={8}>
                            <Col span={12}>
                                <ModalForm.Item >
                                    <AccountDatePicker
                                        labelText={"Dt. Certificação"}
                                        value={certification.certificate_date ? moment(certification.certificate_date, dateFormat) : ""}
                                        format={dateFormat}
                                        placeholder={""}
                                        disabled={modeCertificationModal == modes.VIEW ? true : false}
                                        onChange={handleChangeDateCertification} />
                                </ModalForm.Item>
                            </Col>
                            <Col span={12}>
                                <ModalForm.Item>
                                    <AccountDatePicker
                                        labelText={"Dt. Validade"}
                                        value={certification.expiration_date ? moment(certification.expiration_date, dateFormat) : ""}
                                        format={dateFormat}
                                        placeholder={""}
                                        disabled={modeCertificationModal == modes.VIEW ? true : false}
                                        onChange={handleChangeDateExpiration} />
                                </ModalForm.Item>
                            </Col>
                        </Row>

                        <ModalForm.Item>
                            <AccountInputValue
                                labelText={"Nota"}
                                value={certification.grade}
                                disabled={modeCertificationModal == modes.VIEW ? true : false}
                                onChange={handleChangeGrade} />
                        </ModalForm.Item>

                        <ModalForm.Item>
                            <AccountTextArea
                                labelText={"Observação"}
                                value={certification.observation}
                                disabled={modeCertificationModal == modes.VIEW ? true : false}
                                rows={3}
                                onChange={handleChangeObservation}
                                onKeyUp={limitInputForm}
                                maxLength={1000} />
                                <label className={"feedback-text-cont"}>{limitCharacter}/1000</label>
                                <label style={{ "fontSize": "12px", color: "red", display: hasLimitLength ? "block" : "none" }}>{msgLimitLength}</label>
                        </ModalForm.Item>

                        {renderModificationUserName()}
                    </ModalForm>
                </>
            )
        }
    }

    return (
        <AccountModal
            visible={showCertificationModal}
            title={renderTitle()}
            onCancel={handleClear}
            footer={renderButtons()}>

            {renderForm()}
        </AccountModal>
    )
}

export default ModalCertification;

